import React from "react";
import { deleteUser } from "../../lib/session";
import { Button } from "antd";
import "./index.less";

export default ({ history, track }) => {
  const logout = () => {
    const logoutFunc = () => {
      deleteUser();
      history.push("/");
    };
    track("logout", "user-logout", logoutFunc, logoutFunc);
  };

  return (
    <section id="footer">
      <div className="button-container">
        <Button type="normal" htmlType="submit" onClick={logout}>
          Log out
        </Button>
      </div>
    </section>
  );
};
